'use client'
import { Typography } from 'components/Contentful'
import { _get } from 'utils/shared'
import { AuthorTag } from 'components/AuthorTag'
import { Grid, Divider } from '@achieve/ascend'
import { useContentfulInspectorMode } from '@contentful/live-preview/react'

function ArticleHeading({ content, hasImage }) {
  const inspectorProps = useContentfulInspectorMode()
  const title = _get(content, 'pressData.items[0].fields.title')
  const subtitle = _get(content, 'pressData.items[0].fields.subtitle')
  const publishDate = _get(content, 'pressData.items[0].fields.publishDate')
  const authorName = _get(content, 'pressData.items[0].fields.author.fields.authorName')
  const authorPhoto = _get(content, 'pressData.items[0].fields.author.fields.authorPhoto')
  const entryId = _get(content, 'pressData.items[0].sys.id')

  return (
    <>
      {title && (
        <Typography
          content={title}
          component="h1"
          className="text-[#1d252f] mt-0 mb-8 mx-0 lg:mt-0 lg:mb-6 lg:mx-0 headingMd lg:headingLg font-medium!"
          data-testid="press-article-title"
          {...inspectorProps({
            entryId,
            fieldId: 'title',
          })}
        />
      )}
      {subtitle && (
        <Typography
          content={subtitle}
          className=" mt-0 mb-8 mx-0 lg:mt-0 lg:mb-6 lg:mx-0 bodySm lg:bodyLg leading-[170%]"
          data-testid="press-article-subtitle"
          {...inspectorProps({
            entryId,
            fieldId: 'subtitle',
          })}
        />
      )}
      {publishDate && (
        <Grid
          container
          className="flex justify-between items-center mt-0 mb-8 mx-0 lg:mt-0 lg:mb-8 lg:mx-0"
          data-testid="press-article-author-and-social-media"
        >
          <AuthorTag
            authorName={authorName}
            authorPhoto={authorPhoto}
            publishDate={publishDate}
            data-testid="press-article-author-tag"
            entryId={entryId}
          />
        </Grid>
      )}

      <Divider className={hasImage ? 'mt-8 lg:mt-16' : 'mx-0 my-8 lg:mt-16 lg:mb-0 lg:mx-0'} />
    </>
  )
}

export { ArticleHeading }
